import { render, staticRenderFns } from "./enterpriseTabs.vue?vue&type=template&id=4888945c&scoped=true"
import script from "./enterpriseTabs.vue?vue&type=script&lang=js"
export * from "./enterpriseTabs.vue?vue&type=script&lang=js"
import style0 from "./enterpriseTabs.vue?vue&type=style&index=0&id=4888945c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4888945c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4888945c')) {
      api.createRecord('4888945c', component.options)
    } else {
      api.reload('4888945c', component.options)
    }
    module.hot.accept("./enterpriseTabs.vue?vue&type=template&id=4888945c&scoped=true", function () {
      api.rerender('4888945c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/enterpriseTabs.vue"
export default component.exports